import { useQuery, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { IssueTemplate } from 'types';
import { refetchUserOnError } from 'utils/refetchUserOnError';

const getTemplates = async (
  projectId?: string,
  issueType?: string,
  orgOnly?: boolean
): Promise<IssueTemplate[]> => {
  const params: {
    projectId?: string;
    issueType?: string;
    orgOnly?: string;
  } = {};
  if (projectId) {
    params.projectId = projectId;
  }
  if (issueType) {
    params.issueType = issueType;
  }
  if (orgOnly) {
    params.orgOnly = 'true';
  }
  const { data } = await customAxios.get<IssueTemplate[]>('/issue-templates', {
    params,
  });
  return data;
};

export const useGetIssueTemplates = (
  projectId?: string,
  issueType?: string,
  orgOnly?: boolean
) => {
  const queryClient = useQueryClient();

  return useQuery<IssueTemplate[]>({
    queryKey: ['issue-templates', projectId, issueType, orgOnly],
    queryFn: () => getTemplates(projectId, issueType, orgOnly),
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
